import { render } from "./BuyInteractionVideo.vue?vue&type=template&id=8b1d95fe"
import script from "./BuyInteractionVideo.vue?vue&type=script&lang=js"
export * from "./BuyInteractionVideo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Vue3\\player-video-pepsi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__